import { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { DbNode } from '../../../types/node';
import { NodeService } from '../../../http/node-service';

interface DeleteNodeDialogProps {
    node: DbNode;
    open: boolean;
    onClose: () => void;
    onDeleted: () => void;
}

const DeleteNodeDialog = ({ node, open, onClose, onDeleted }: DeleteNodeDialogProps) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleClose = () => {
        if (loading) return;
        setError('');
        onClose();
    };

    const handleConfirm = async () => {
        setLoading(true);
        setError('');
        try {
            await NodeService.remove(node.node_id);
            onDeleted();
            onClose();
        } catch {
            setError('Не удалось удалить');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            onKeyDown={(e) => { if (e.key === 'Enter' && !loading) handleConfirm(); }}
        >
            <DialogTitle>Удалить узел</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Вы точно хотите удалить «{node.name}»?
                </DialogContentText>
                {error && <DialogContentText color="error" sx={{ mt: 1 }}>{error}</DialogContentText>}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={loading}>
                    Отмена
                </Button>
                <Button onClick={handleConfirm} color="error" variant="contained" disabled={loading} disableElevation autoFocus>
                    Удалить
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteNodeDialog;
